import { Get } from '../helpers';
import type { GraphicInterface } from '@/types/greenroom/graphics.types';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const LoadGraphics = async (meetingId: number): Promise<GraphicInterface[]> => {
  return Get({
    host: GREENROOM_HOST,
    path: `/v2/greenroom/graphics/${meetingId}`,
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default LoadGraphics;
